import * as Sentry from '@sentry/react';
import merge from 'lodash/merge';
import omit from 'lodash/omit';

function sanitizeResourceForSentry(resource) {
  if (!resource) {
    return resource;
  }

  resource.attributes = omit(resource.attributes, [
    'address_city',
    'address_line1',
    'address_line2',
    'birthdate',
    'cardholder_name_first',
    'cardholder_name_last',
    'city',
    'email',
    'first_name',
    'last_name',
    'name',
    'phone',
    'state',
    'street',
    'street',
    'street_one',
    'street_two',
    'verified_email',
    'verified_phone',
  ]);
  return resource;
}

function sanitizeStateForSentry(state) {
  let reportedState = Object.assign({}, { view: {} }, state);
  reportedState.view.resources = {};
  reportedState = omit(reportedState, ['client', 'hydration', 'router', 'resources']);

  return reportedState;
}

/**
 * Sends an error to Sentry, with extra data if the error is from a request
 *
 * noop if we don't configure sentry
 *
 * @param {Error|String} error
 * @param {Object} extra any extra parameters to send to Sentry
 *   Note: 'fingerprint' is not considered an "extra" and will be used to fingerprint the error for grouping.
 */
export function captureSentryError(error, extra = {}) {
  // sanitize redux state if provided as part of `extra` hash
  if (extra?.state) {
    extra.state = sanitizeStateForSentry(extra.state);
  }

  // Handle errors that have a response from the server (returned by Axios)
  const httpExtras = {};

  if (error.response) {
    httpExtras.request = {
      method: error?.response?.config?.method,
      url: error?.response?.config?.url,
    };
    httpExtras.response = {
      data: error?.response?.data,
    };

    const parsedBody = JSON.parse(error?.response?.config?.data ?? '{}');

    httpExtras.request.body = {
      data: sanitizeResourceForSentry(parsedBody.data),
    };
  }

  const data = {};
  if (extra.fingerprint) {
    data.fingerprint = extra.fingerprint;
  }

  data.extra = omit(merge(httpExtras, extra), ['fingerprint']);

  Sentry.captureException(error, data);
}
